import { HttpHandler, HttpRequest, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingDialogService } from '../../shared/loading/loading-dialog.service';
import { Injectable } from '@angular/core';
import { SharedDataService } from 'src/services/shared-data.service';
  
  @Injectable()
  export class HttpLoadingInterceptor implements HttpInterceptor {
    constructor(private loadingDialogService: LoadingDialogService, private sharedDataService: SharedDataService) {}
  
    intercept( request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
     
     if (request.url.indexOf("response/answeronly") === -1 ){
     //this was added so the loading popup doesn't flicker
      if (request.url.indexOf("response") != -1 ){
        this.loadingDialogService.openDialog();
      }
        return next.handle(request).pipe(          
          finalize(() => {
            this.loadingDialogService.hideDialog();
          })
        ) as Observable<HttpEvent<any>>;  

      } else {

        this.sharedDataService.SetSharedIsQuestionSaving(true);
        return next.handle(request).pipe(        
          finalize(() => {
            this.sharedDataService.SetSharedIsQuestionSaving(false)
          })
        ) as Observable<HttpEvent<any>>;  
      
      } 
         

    }
  }
  